import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/patron/checkins/distinct/{currentPage}/{pageSize}'
const method = 'get'

interface UseGetPatronListByLeCheckinsParams {
  paginationModel: any
  licensedEstablishmentId: number
  startDate: Date
  endDate: Date
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd HH:mm:ss')

export const useGetPatronListByLeCheckinsForExport = ({
  paginationModel,
  licensedEstablishmentId,
  startDate,
  endDate,
}: UseGetPatronListByLeCheckinsParams) =>
  useApiQuery({
    path,
    method,
    queryKey: [
      '/le-connect/patron/checkins/distinct/export/1/1000000',
      paginationModel,
      licensedEstablishmentId,
      startDate,
      endDate,
    ],
    queryArgs: {
      currentPage: 1,
      pageSize: 1000000,
      licensedEstablishmentId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
  })
